// extracted by mini-css-extract-plugin
module.exports = {"noTransform":"permissionMenuList_noTransform__cwOgv"};